import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  Grid,
  Divider
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { appConfig } from '../../config/app';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        mt: 'auto',
        py: 4
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-between" alignItems="flex-start">
          {/* App Info */}
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>
              {appConfig.name}
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              {appConfig.description}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Version {appConfig.version}
            </Typography>
          </Grid>

          {/* Links */}
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {appConfig.footer.links.map((link) => (
                <Link
                  key={link.path}
                  component={RouterLink}
                  to={link.path}
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                      color: 'primary.main'
                    }
                  }}
                >
                  {link.title}
                </Link>
              ))}
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        {/* Copyright */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} {appConfig.name}. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 